import type { AxiosResponse } from "axios";

import http from "@/api/instance";

type NotificationsReadByChainIdResponseType = { data: number };

type NotificationsReadByChainIdRequestType = (args: chainId) => Promise<AxiosResponse<NotificationsReadByChainIdResponseType>>;

export const readNotificationsByChainId: NotificationsReadByChainIdRequestType = (chainId) => http.httpCore.post(`notifications/chain/${chainId}/read`);
